import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import Editor from 'components/Editor';
import Progress from 'components/Misc/Progress';
import Container from 'components/Misc/Container';
import { Title, Preamble } from 'components/Misc/Typography';

import { useAppStore } from 'store/useAppStore';

const Profile = () => {
	// Cache current object's id
	const { id } = useParams();

	// Use app's store
	const setTitle = useAppStore(state => state.setTitle);

	// Store requested article
	const [[article, progress], collect] = useCollect(`articles/${id}`);

	// Set page's title
	useEffect(() => setTitle(article?.titlePublic), [article]);

	// Collect article on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<Container className="mx-auto max-w-screen-md p-4 space-y-4">
			{/* Show progress */}
			<Progress progress={progress} />

			{/* Show collected article */}
			<Show if={article?.id && !progress}>
				{/* Article's information */}
				<Title
					title={article?.title}
					subtitle={DayJs(article?.availableFrom || article?.createdAt).format('D. MMM, YYYY')}
					className="text-2xl font-bold tracking-wide"
				/>

				{/* Article's thumbnail if present */}
				<Show if={article?.thumbnail}>
					<img
						alt={article?.thumbnail}
						src={`${process.env.REACT_APP_CDN}/articles/${article?.slug}/${article?.thumbnail}`}
						className="mx-auto max-w-full max-h-96 rounded-lg"
					/>
				</Show>

				{/* Article's preamble if present */}
				<Show if={article?.description}>
					<Preamble value={article?.description} />
				</Show>

				{/* Article's content */}
				<Editor
					readOnly
					path="articles"
					folder={article?.slug}
					value={article?.content}
				/>
			</Show>
		</Container>
	);
};

export default Profile;